<!-- 社会责任 -->
<template>
  <div class="body">
    <top left="Magazine" right="About" leftpage="magazine" rightpage="about"></top>

    <div class="turnani" id="turnani" :style="`transform: translateX(${turnleft}px);`">
      <img @click=" goStory(newissue,item[1]) " v-for="(item, index) in lists" :src="item[0]">
      <img @click=" goStory(newissue,item[1]) " v-for="(item, index) in lists" :src="item[0]">
      <img @click=" goStory(newissue,item[1]) " v-for="(item, index) in lists" :src="item[0]">
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      word: "", // 搜索热词
      turnleft: 0, // 动画向左的偏移量
      turn: null, // 循环动画实例
      speed: 2, // 动画速度
      mainW: window.innerWidth,// 屏幕宽度
      newissue:this.$store.state.Carousel["issue"],
      //Carousellenth:this.$store.state.Carousel["imgs"].length,//额外首页轮播图，跳转跳过index
      lists: this.$store.state.Carousel["imgs"] //增加额外首页轮播图
    };
  },
  methods: {
    goStory: function (issuenum,storeid) {
      console.log(issuenum,storeid)
      // this.$router.push({name: pagename, query: {id: id,zindex:zindex}});
      this.$router.push({name: "storyNew", query: {issue:issuenum,storeid:storeid}});
    },
  },
  mounted() {
    // 获取所有需要监测的图片元素
    const imagesToObserve = document.querySelectorAll('img');
    this.turn = setInterval(() => {
      this.turnleft = this.turnleft - this.speed;
      if(imagesToObserve[this.lists.length].getBoundingClientRect().left <= 0){
        this.turnleft = 0;
      }
    }, 10);
  },
};

</script>

<style scoped lang='scss'>
.body {
  // height: 100%;
  background-color: #F5F5F5;
  overflow: hidden;
  position: fixed;
  // padding-bottom: 60px;

  .turnani{
    display: flex;
    position: fixed;
    height: 93vh;
    height: 93svh;
    img{
      width: auto;
      height: 100%;
      cursor: pointer;
    }
  }
}

@media screen and ( max-width: 750px ) {
//   .body {
//    padding-bottom: 7vh;
// }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue